import { render, staticRenderFns } from "./NewsWorkflow.vue?vue&type=template&id=da4bd75a"
import script from "./NewsWorkflow.js?vue&type=script&lang=js&external"
export * from "./NewsWorkflow.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports